import React from "react";
import { BPShiftStatus } from "./bpShiftStatus";
export const shiftIcons = (shift) => {
    const shiftIcon = (shiftStatus) => {
        switch (shiftStatus) {
            case BPShiftStatus.preplanned: return (React.createElement("i", { className: "fa-solid fa-circle shiftstatus-preplanned no-text", title: "Under planl\u00E6gning" }));
            case BPShiftStatus.planned: return (React.createElement("i", { className: "fa-solid fa-circle shiftstatus-planned no-text", title: "Planlagt" }));
            default: return (React.createElement("i", { className: "fa-solid fa-circle-xmark shiftstatus-unknown", title: "Ukendt" }));
        }
    };
    return (React.createElement(React.Fragment, null, shiftIcon(shift.status)));
};
